import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  gap: 1.6rem;
  margin: 1.6rem 2.8rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol';

  @media (orientation: portrait) {
    justify-content: unset;
    gap: 0;
  }
`;

export const Header = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr .3fr;
  gap: 0.2rem;

  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);

  @media (orientation: portrait) {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.2rem;
    padding-bottom: 1.4rem;
  }
`;

export const HeaderColumn = styled.div<{ first?: boolean }>`
  overflow: hidden;

  @media (orientation: portrait) {
    grid-column: ${props => (props.first ? `span 2` : `0`)};
  }
`;

export const Box2 = styled.div`
  text-align: center;
`;

export const Box3 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6vw;
`;

export const Box4 = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
`;

export const PersonTitle = styled.div`
  font-weight: 400;
  color: #ffffff;
  font-size: calc(0.9rem + 0.390625vw);

  display: flex;
  align-items: center;
  > * {
    margin-right: 0.4rem;
  }
`;

export const PersonName = styled.div`
  font-weight: 590;
  color: #ffffff;
  font-size: calc(1.2rem + 0.390625vw);

  display: flex;
  align-items: center;
  > * {
    margin-left: 0.6rem;
  }

  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const Text1 = styled.div`
  font-weight: 400;
  font-size: calc(0.8rem + 0.390625vw);
  color: #ffffff;

  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const Text2 = styled.div`
  font-size: 1rem;
  line-height: 1.2rem;
  color: #ffffff;
  opacity: 0.5;
`;

export const Text3 = styled.div`
  text-align: right;
  font-weight: 590;
  font-size: 27.65px;
  line-height: 33px;
  color: #ffffff;
`;

export const Text4 = styled.button<{ hide?: boolean }>`
  padding: 0;
  font-weight: 600;
  font-size: 1.125rem;
  line-height: 1.2rem;
  text-transform: uppercase;
  color: #00a7f7;
  background: transparent;
  border: 0;
  box-shadow: none;
  visibility: ${props => (props?.hide ? 'hidden' : 'visible')};

  &:disabled {
    opacity: 0.5;
  }
`;

export const Text5 = styled.p`
  text-align: center;
  line-height: 1.4;
  opacity: 0.5;
  margin-bottom: 1rem;
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  gap: 3rem;

  @media (orientation: portrait) {
    grid-template-columns: 1fr;
    gap: 0;
  }
`;

export const SideColumn = styled.div<{ gridRowNumber?: number }>`
  @media (orientation: portrait) {
    display: grid;
    grid-template-columns: repeat(4, auto);
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    grid-row: ${props => (props.gridRowNumber ? props.gridRowNumber : 'auto')};
  }
`;

export const MainColumn = styled.div<{ gridRowNumber?: number }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media (orientation: portrait) {
    margin-top: 1.6rem;
    grid-row: ${props => (props.gridRowNumber ? props.gridRowNumber : 'auto')};
  }
`;

export const Footer = styled.div`
  display: grid;
  margin: 1.2rem 0;

  & > * {
    grid-row: 1 / span 1;
    grid-column: 1 / span 1;
  }
`;
